var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnPosition32 = function SvgLightIcnPosition32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6D7D90",
    d: "M15.5 16h2v14h-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 10.5,
    r: 7.5,
    fill: "#FF4C4C"
  })));
};
export default SvgLightIcnPosition32;